import { render } from "./create.vue?vue&type=template&id=57c343f2&ts=true"
import script from "./create.vue?vue&type=script&scoped=true&lang=ts"
export * from "./create.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__